/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AvatarType {
    TEXT = 'text',
    IMAGE = 'image',
}
